import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { authApi } from "./service/authService";
import { trackersApi } from "./service/trackers_service";

const rootReducer = combineReducers({
  loading:false,
  [authApi.reducerPath]: authApi.reducer,
  [trackersApi.reducerPath]: trackersApi.reducer,
});

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      // adding the api middleware enables caching, invalidation, polling and other features of `rtk-query`
      getDefaultMiddleware().concat(authApi.middleware, trackersApi.middleware),
    preloadedState,
  });
};
